import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import ScrollOut from "scroll-out";

const Welfare = () => {
    useEffect(() => {
        ScrollOut({
            threshold: 0.3,
            once: true
        });
    }, []);

    return (
        <>
            <SubHead title="복리후생" eng="WELFARE"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <p class="tit-guide-sbj" data-scroll>
                        임직원의 삶의 질을 높이고, <br />
                        가족친화적인 즐거운 일터를 만들기 위해 <br />
                        <b>다양한 복지제도</b>를 시행하고 있습니다.
                    </p>

                    <div className="welfare-infos-wrap gray-back-bg">
                        <ul className="welfare-infos">
                            <li data-scroll>
                                <div className="icon_box n01"></div>
                                <div className="text_box">
                                    <p className="sbj">보상제도</p>
                                    <p className="txt">4대보험 및 퇴직금(퇴직연금제도)</p>
                                </div>
                            </li>
                            <li data-scroll>
                                <div className="icon_box n05"></div>
                                <div className="text_box">
                                    <p className="sbj">자녀 학자금지원</p>
                                    <p className="txt">고등학교, 대학교</p>
                                </div>
                            </li>
                            <li data-scroll>
                                <div className="icon_box n02"></div>
                                <div className="text_box">
                                    <p className="sbj">선택적 복지</p>
                                    <p className="txt">재직중인 직원을 대상으로 복지카드 지급</p>
                                </div>
                            </li>
                            <li data-scroll>
                                <div className="icon_box n08"></div>
                                <div className="text_box">
                                    <p className="sbj">포상제도</p>
                                    <p className="txt">
                                        {/* 우수사원 해외연수 <br /> */}
                                        우수직원 포상(안전보건, 혁신과제 등 idea공모)
                                    </p>
                                </div>
                            </li>
                            <li data-scroll>
                                <div className="icon_box n07"></div>
                                <div className="text_box">
                                    <p className="sbj">의료 및 건강검진지원</p>
                                    <p className="txt">단체/실손보험 가입 임직원 건강검진 지원</p>
                                </div>
                            </li>
                            <li data-scroll>
                                <div className="icon_box n03"></div>
                                <div className="text_box">
                                    <p className="sbj">여가생활지원</p>
                                    <p className="txt">휴양시설 운영 및 이용</p>
                                </div>
                            </li>
                            <li data-scroll>
                                <div className="icon_box n09"></div>
                                <div className="text_box">
                                    <p className="sbj">생활안정 지원</p>
                                    <p className="txt">명절/생일, 창사기념일/근로자의날 경조금 및 상조 지원 </p>
                                </div>
                            </li>
                            <li data-scroll>
                                <div className="icon_box n06"></div>
                                <div className="text_box">
                                    <p className="sbj">자기계발 지원</p>
                                    <p className="txt">
                                        자격증 취득 지원
                                        <br />
                                        장기근속 (10년/20년) 휴가 및 지원금
                                    </p>
                                </div>
                            </li>
                            <li data-scroll>
                                <div className="icon_box n04"></div>
                                <div className="text_box">
                                    <p className="sbj">업무복 지원</p>
                                    <p className="txt">춘추복/동계복/방한복 지급</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Welfare;
